import {AboutPage} from './components/AboutPage';
import {ConsumerPortalLayout} from './components/ConsumerPortalLayout';
import {ApplicationPage} from './components/ApplicationPage';

export default {
  AboutPage, ConsumerPortalLayout, ApplicationPage
}